module.exports = __webpack_public_path__ + "images/model-360-c0f538a0d62a137b92d9b1ee38f01471.svg";